import React from 'react';
import styled, { css } from 'styled-components';
import { LocationDescriptor } from 'history';
import { partnerStyled } from 'packages/smart-home-support/partner';
import DynamicLink from './DynamicLink';
import { CallToAction } from '../styling/styles';
import { LinkId } from '../constants';

export type ButtonProps = {
  id?: LinkId;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
  value?: string;
  to?: LocationDescriptor;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
  target?: string;
  disabled?: boolean;
  inverted?: boolean;
  showLeavingIcon?: boolean;
};

const commonStyles = css<ButtonProps>`
  ${CallToAction}
  margin: 0;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  transition: background-color 0.2s;
  ${(props) => props.disabled && 'background-color: gray'};
  ${partnerStyled.Verizon`
    font-weight: bold;
  `}
`;

const ButtonButton = styled.button`
  ${commonStyles}
`;

const ButtonSubmit = styled.input`
  ${commonStyles}
`;

const ButtonDynamicLink = styled(DynamicLink)`
  ${commonStyles}
  text-decoration: none;
`;

const ButtonSpan = styled.span`
  ${commonStyles}
  cursor: initial;
`;

const Button: React.FC<ButtonProps> = (props) => {
  const { children, value, to, target, showLeavingIcon, ...commonProps } = props;
  commonProps.onClick = (e) => {
    return props.disabled ? e.preventDefault() : props.onClick && props.onClick(e);
  };

  if (value) {
    return <ButtonSubmit type="button" value={value} {...commonProps} />;
  }

  if (to) {
    return (
      <ButtonDynamicLink showLeavingIcon={showLeavingIcon} to={to} target={target} {...commonProps}>
        {children}
      </ButtonDynamicLink>
    );
  }

  if (props.onClick || props.type === 'submit') {
    return <ButtonButton {...commonProps}>{children}</ButtonButton>;
  }

  return <ButtonSpan {...commonProps}>{children}</ButtonSpan>;
};

export default Button;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Button.tsx